import { render, staticRenderFns } from "./examationDetailsPage.vue?vue&type=template&id=5181ecf8"
import script from "./examationDetailsPage.vue?vue&type=script&lang=js"
export * from "./examationDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./examationDetailsPage.vue?vue&type=style&index=0&id=5181ecf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports